import PropTypes from 'prop-types';
import { Marker } from 'react-mapbox-gl';
import mapPin from 'assets/images/location_pin.png';

const MapPinMarker = ({ coordinates, anchor = 'bottom', offset = [0, 10], ...props }) => {
	return (
		<Marker coordinates={coordinates} anchor={anchor} offset={offset} {...props}>
			<img src={mapPin} alt={'map-pin'} />
		</Marker>
	);
};

MapPinMarker.propTypes = {
	coordinates: PropTypes.arrayOf(PropTypes.number).isRequired,
	anchor: PropTypes.string,
	offset: PropTypes.arrayOf(PropTypes.number)
};

export default MapPinMarker;
